import Vue from 'vue';
import VueRouter from 'vue-router';
// import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/our-square',
  },
  // ourSquare
  {
    path: '/our-square',
    name: 'ourSquare',
    component: () =>
      import(/* webpackChunkName: "ourSpace" */ '@/views/ourSquare/index.vue'),
  },
  // ownSpace
  {
    path: '/own-Space',
    name: 'ownSpace',
    component: () =>
      import(/* webpackChunkName: "ourSpace" */ '@/views/ownSpace/index.vue'),
  },
  // 后台管理
  {
    path: '/backend-system',
    name: 'backendSystem',
    component: () =>
      import(
        /* webpackChunkName: "ourSpace" */ '@/views/backendSystem/index.vue'
      ),
  },

  // 以下为待定区域
  // {
  //   path: "/",
  //   name: "Home",
  //   component: Home,
  // },
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
